<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.list.user.label.description')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>               
                <p class="sub-header">
                    {{$t('string.msg.list.user.filter.label.description')}}
                </p>
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.list.user.label.by.type')}}
                            </label>
                            <select v-model="userType" class="form-control">
                                <option :value="null" selected>{{$t('string.msg.select.user.type.placeholder')}}</option>
                                <option value="USER-CUSTOMER">{{$t('string.msg.list.user.type.trucker')}}</option>
                                <option value="USER-COMPANY" selected>{{$t('string.msg.list.user.type.company')}}</option>
                            </select>
                        </div>

                        <div class="form-group col-md-6" v-if="userType != null && userType == 'USER-CUSTOMER'">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.list.user.label.search')}}
                            </label>
                            <input type="text" v-model="filters.name" class="form-control">
                        </div>
                        <div class="form-group col-md-6" v-else-if="userType == 'USER-COMPANY'">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.companies.search.label.name.company')}}
                            </label>
                            <input type="text" v-model="filters.name" class="form-control">
                        </div>
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                    </div>
                </form>

                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.table.list.user.label.name')}}</th>
                                <th class="border-top-0" v-if="userType == 'USER-CUSTOMER'">{{$t('string.msg.trucker.label.phone')}}</th>
                                <th class="border-top-0" v-if="userType == 'USER-COMPANY'">{{$t('string.msg.table.list.user.label.email')}}</th>
                                <th class="border-top-0">{{$t('string.msg.table.list.user.label.type')}}</th>
                                <th class="border-top-0">{{$t('string.msg.table.list.user.label.company')}}</th>
                                <th class="border-top-0">{{$t('string.msg.table.list.user.label.status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                              <tr v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                                <td>
                                    <span>
                                        {{toUpperCase(item.firstName) + ' ' + toUpperCase(item.lastName) }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.type == 'USER-CUSTOMER'">
                                        {{(item.primaryPhone)}}
                                    </span>
                                    <span v-else-if="item.type == 'USER-COMPANY'">
                                        {{(item.email)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.type == 'USER-COMPANY'">
                                        {{$t('string.msg.user.type.company')}}
                                    </span>
                                    <span v-else-if="item.type == 'USER-CUSTOMER'">
                                        {{$t('string.msg.user.type.customer')}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.companyUser && item.companyUser.company">
                                        {{ (item.companyUser.company.fantasyName)}}
                                    </span>
                                    <span v-else style="color:red">
                                        {{'X'}}
                                    </span>
                                </td>
                                <td>
                                  <span v-if="item.status">
                                        {{toUpperCase($t(item.status))}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="errors.length" class="alert alert-danger">
                    <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                    <ul>
                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtListUser';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);

export default {
  name: 'ListUser',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
    
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        userType: null,
        PageNumbers:1,
        pageOfItems: [],
        filters: {
            status:"ACTIVE",
            name: "",
            isHideDetailsCompany: false,
            isHideDetailsManufecturerFamily: true,
            isHideDetailsCertifies: true,
            isHideDetailsServiceFamilies: true,
            skip: 0,
            limit: 999999
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
